import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Hide header on root login screen? we keep show on all
  const handleClick = async () => {
    if (user) {
      await logout();
      navigate('/', { replace: true });
    } else {
      navigate('/login');
    }
  };

  return (
    <header className="w-full flex justify-between items-center px-4 py-2 bg-gray-900/80 text-sm border-b border-gray-800 sticky top-0 z-50">
      <Link to="/" className="text-purple-400 font-semibold tracking-wide">
        JukeHive
      </Link>
      {location.pathname !== '/login' && (
        <button
          onClick={handleClick}
          className="btn-secondary px-3 py-1"
        >
          {user ? 'Sign Out' : 'Sign In'}
        </button>
      )}
    </header>
  );
};

export default Header;
